/**
 * Resolve an object in a page-scoped JSONL stream. Object records do not
 * repeat their page number; a {"page": n} header establishes context.
 */
export function findExportObject(exportData, pageId, objectId) {
    let currentPage = null;
    for (const item of exportData ?? []) {
        if (item.page !== undefined && item.id === undefined) {
            currentPage = Number(item.page);
            continue;
        }
        if (currentPage === Number(pageId) && Number(item.id) === Number(objectId)) return item;
    }
    return null;
}

/** Carry the current page-header context forward while traversing JSONL rows. */
export function getExportPageContext(currentPageId, item) {
    return item?.id === undefined && item?.page !== undefined
        ? Number(item.page)
        : currentPageId;
}
